import { render, staticRenderFns } from "./CategoryGroup.vue?vue&type=template&id=5ec886ca"
import script from "./CategoryGroup.vue?vue&type=script&lang=ts"
export * from "./CategoryGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports